import React from "react"

export function MenuItemTrailing({ children }: { children: React.ReactNode }) {
  return <span data-slot="menu-item-trailing">{children}</span>
}

MenuItemTrailing.displayName = "Menu.ItemTrailing"
